import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import {
    LinearProgress,
    Grid,
    InputLabel,
    MenuItem,
    FormControl,
    Input,
    ListItemText,
    Select,
    Typography,
    Tooltip
} from '@material-ui/core';
import Route from '../../static/svg/Route';
import Place from '../../static/svg/Place';

import { Checkbox, SnackbarContent, VSpacer } from 'sm-react-components';
import UsageChart from '../components/charts/UsageChart';
import RequestPieChart from '../components/charts/RequestPieChart';
import StatusPieChart from '../components/charts/StatusPieChart';

import Error from '../components/Error';
import * as requests from '../../infrastructure/requests';

const styles = theme => ({
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 300
    },
    inlineHeader: {
        display: 'inline-block',
        paddingRight: '10px'
    },
    startDateSelector: {
        display: 'inline-block'
    },
    keyimage: {
        color: 'gray',
        width: '50%',
        height: '50%',
        marginTop: 'auto',
        marginBottom: 'auto'
    },
    divKeyContainer: {
        width: '100px',
        height: '100px',
        backgroundColor: 'Gainsboro',
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center'
    }
});

class KeyStatistics extends Component {
  state = {
      statistics: undefined,
      filters: {
          keys: undefined,
          requests: [],
          statuses: undefined,
          startDate: new Date('2018-08-01'),
          endDate: undefined
      },
      loading: false,
      error: undefined,
      startDateOffset: 90 * 24 * 3600
  };

  componentDidMount() {
      this.handleStartDateOffset(this.state.startDateOffset);
  }

  load = async () => {
      try {
          this.setState({
              loading: true
          });
          const filters = this.mergeFilters(this.state.filters, this.props.filters);
          this.setState({
              statistics: await requests.getLogStats(
                  filters.keys,
                  filters.requests,
                  filters.statuses,
                  filters.startDate,
                  filters.endDate
              ),
              loading: false
          });
      } catch (error) {
          this.setState({
              loading: false,
              error: error.message
          });
      }
  };

  mergeFilters(filters1, filters2) {
      return {
          ...filters1,
          ...filters2
      };
  }

  handleStartDateOffset = startDateOffset => {
      if (startDateOffset === null) return;
      this.setState(
          {
              startDateOffset,
              filters: {
                  ...this.state.filters,
                  startDate: new Date(new Date().getTime() - startDateOffset * 1000)
              }
          },
          this.load
      );
  };

  handleRequestsFilterUpdate = event => {
      this.setState(
          {
              ...this.state,
              filters: {
                  ...this.state.filters,
                  requests: event.target.value
              }
          },
          this.load
      );
  };

  render() {
      const { loading, error, statistics, startDateOffset, filters } = this.state;
      const { classes } = this.props;
      if (error) {
          return <Error message={error} />;
      }
      if (statistics !== undefined && statistics.size === 0) {
          return <SnackbarContent message="No request recorded yet." />;
      }
      return (
          <Fragment>
              {loading && <LinearProgress />}
              <Grid container>
                  <Grid item lg={6}>
                      <Grid container>
                          <Grid item lg={2}>
                              <div className={classes.divKeyContainer}>
                                  <Route className={classes.keyimage} />
                              </div>
                          </Grid>
                          <Grid item lg={10}>
                              <Grid container direction="column">
                                  <Grid item>
                                      <Tooltip
                                          title="OptimizerV1 and OptimizerV1-get"
                                          placement="left"
                                      >
                                          <Typography variant="h4">Optimizer</Typography>
                                      </Tooltip>
                                  </Grid>
                                  <Grid item>
                                      <CounterComponent
                                          statistics={statistics}
                                          type="optimizerV1"
                                      />
                                  </Grid>
                              </Grid>
                          </Grid>
                      </Grid>
                  </Grid>
                  <Grid item lg={6}>
                      <Grid container>
                          <Grid item lg={2}>
                              <div className={classes.divKeyContainer}>
                                  <Place className={classes.keyimage} />
                              </div>
                          </Grid>
                          <Grid item lg={10}>
                              <Grid container direction="column">
                                  <Grid item>
                                      <Typography variant="h4">Places</Typography>{' '}
                                  </Grid>
                                  <Grid item>
                                      <CounterComponent //COUNTER COMPONENT IS DEFINED BELOW
                                          statistics={statistics}
                                          type="placesProfilerV1"
                                      />
                                  </Grid>
                              </Grid>
                          </Grid>
                      </Grid>
                  </Grid>
              </Grid>
              <VSpacer medium />
              <Grid container justify="center">
                  <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-checkbox">Requests</InputLabel>
                      <Select
                          multiple
                          value={filters.requests}
                          onChange={this.handleRequestsFilterUpdate}
                          input={<Input id="select-multiple-checkbox" />}
                          renderValue={selected => selected.join(', ')}
                          // MenuProps={MenuProps}
                      >
                          {['optimizerV1', 'optimizerV1-get', 'placesProfilerV1'].map(
                              request => (
                                  <MenuItem key={request} value={request}>
                                      <Checkbox
                                          checked={filters.requests.indexOf(request) > -1}
                                      />
                                      <ListItemText primary={request} />
                                  </MenuItem>
                              )
                          )}
                      </Select>
                  </FormControl>
                  <FormControl className={classes.formControl}>
                      <InputLabel htmlFor="select-multiple-checkbox">Since</InputLabel>
                      <Select
                          value={startDateOffset}
                          native
                          onChange={event => this.handleStartDateOffset(event.target.value)}
                          className={classes.startDateSelector}
                      >
                          <option value={7 * 24 * 3600}>7 days</option>
                          <option value={14 * 24 * 3600}>14 days</option>
                          <option value={30 * 24 * 3600}>30 days</option>
                          <option value={90 * 24 * 3600}>90 days</option>
                      </Select>
                  </FormControl>
              </Grid>
              <VSpacer />
              <Grid container>
                  <UsageChart statistics={statistics} width={12} />
              </Grid>
              <VSpacer />
              <Grid container>
                  <Grid item lg={6}>
                      <Grid container>
                          <StatusPieChart
                              statistics={statistics}
                              width={6}
                              withPercentage
                          />
                      </Grid>
                  </Grid>
                  <Grid item lg={6}>
                      <Grid container>
                          <RequestPieChart
                              statistics={statistics}
                              width={6}
                              withPercentage
                          />
                      </Grid>
                  </Grid>
              </Grid>
          </Fragment>
      );
  }
}

export default withStyles(styles)(KeyStatistics);

const CounterComponent = ({ statistics, type }) => {
    let counts = {};
    if (statistics === undefined || statistics.values === undefined) {
        return null;
    }
    statistics.values.forEach(value => {
    // Add keys
        Object.keys(value.requests || {}).forEach(key => {
            counts[key] = (counts[key] || 0) + value.requests[key];
        });
    });
    const values = Object.keys(counts)
        .sort()
        .map(key => ({
            label: key,
            count: counts[key]
        }));
    let number = undefined;
    if (type === 'optimizerV1') {
        number = values.filter(
            value => value.label === type || value.label === 'optimizerV1-get'
        );
    } else {
        number = values.filter(value => value.label === type);
    }

    return (
        <Grid container spacing={8}>
            <Grid item>
                <Typography variant="h1">
                    {number.length > 0 ? number[0].count : 0}
                </Typography>
            </Grid>
            <Grid item>
                <Grid
                    container
                    direction="column"
                    style={{ height: '87%' }}
                    justify="flex-end"
                >
                    <Grid item>
                        <Typography variant="h4">request</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};
